import {
  collection,
  getDocs,
  firestore,
  doc,
  updateDoc,
  addDoc,
} from "../utils/firebase";
import {
  createAdminUser,
  deleteData,
  getData,
  getSingleData,
  updateData,
} from "./CommonService";
const AdminServices = {
  registerAdmin(body) {
    return createAdminUser(body);
  },

  addAdmin(body) {
    return createAdminUser(body);
  },
  getAllAdmin() {
    return getData("/admins");
  },
  getAdminById(id) {
    return getSingleData("/admins", id);
  },

  updateAdmin(id, body) {
    return updateData("/admins", body, id);
  },
  deleteAdmin(id) {
    deleteData(id, "/admins");
  },
  async updateAppSettings(body) {
    const settingsCollectionRef = collection(firestore, "settings");
    const settingsQuerySnapshot = await getDocs(settingsCollectionRef);

    if (settingsQuerySnapshot.empty) {
      const defaultSettings = body;
      await addDoc(settingsCollectionRef, defaultSettings);
    } else {
      const docRef = doc(
        firestore,
        "/settings",
        settingsQuerySnapshot.docs[0].id
      );
      await updateDoc(docRef, body);
    }
  },
  async getAppSettings() {
    const settingsCollectionRef = collection(firestore, "/settings");
    const settingsQuerySnapshot = await getDocs(settingsCollectionRef);
    if (!settingsQuerySnapshot.empty) {
      return settingsQuerySnapshot.docs[0].data();
    }
    return null;
  },
};

export default AdminServices;
